// extracted by mini-css-extract-plugin
export var brand = "_16-9";
export var button = "_16-0";
export var chevron = "_16-v";
export var chevronButton = "_16-w";
export var content = "_16-n";
export var danger = "_16-g";
export var dangerOutlined = "_16-h";
export var dark = "_16-l";
export var darkTheme = "_16-c";
export var extraSmall = "_16-4";
export var fullWidth = "_16-8";
export var ghost = "_16-d";
export var gray = "_16-t";
export var icon = "_16-p";
export var iconButton = "_16-s";
export var iconButtonBorder = "_16-x";
export var iconButtonBorderDark = "_16-y";
export var iconButtonBorderLight = "_16-z";
export var iconLeft = "_16-q";
export var iconRight = "_16-r";
export var large = "_16-1";
export var light = "_16-m";
export var medium = "_16-2";
export var micro = "_16-5";
export var nano = "_16-7";
export var outlined = "_16-k";
export var pending = "_16-a";
export var primary = "_16-i";
export var shadow = "_16-o";
export var small = "_16-3";
export var solidLight = "_16-e";
export var solidLightBrand = "_16-f";
export var spinner = "_16-u";
export var transparent = "_16-j";
export var warning = "_16-b";
export var wideNano = "_16-6";